(function () {
  function initAwardsSwiper() {
    if (!window.Swiper) return setTimeout(initAwardsSwiper, 100);
    new Swiper('.koc-awards-slider', {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      autoplay: { delay: 3000, disableOnInteraction: false },
      pagination: {
        el: '.koc-awards-slider .swiper-pagination',
        clickable: true,
        bulletClass: 'koc-bullet',
        bulletActiveClass: 'koc-bullet-active'
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAwardsSwiper);
  } else {
    initAwardsSwiper();
  }
})();